/* eslint-disable react/jsx-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
import _ from "lodash";
import logger from "../../utils/LoggerFrontend";
import React from "react";
import Reflux from "reflux";
import classNames from "classnames";
import { Redirect } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import moment from "moment";
import Actions from "../../Actions";
import StatusStore from "../../Stores/StatusStore";
import CampaignSidebar from "./Campaign__Read-Sidebar.jsx";
import AdsetLeftSidebar from "./Adset__Left-Sidebar.jsx";
import CampaignChart from "./Campaign__Chart.jsx";
import CampaignInProgress from "./Campaign__InProgess.jsx";
import AdPreview from "./Campaign__AdPreview.jsx";
import LoadingView from "../../Components/LoadingView";
import {
  renderStatus,
  sumValueFromDictKey,
  remainingDaysString,
  renderStatusSort,
  getSumByChannelAndMetricField,
  getJobCategoryName,
  formatIntlNumber
} from "../../utils/Helpers";
import { getPermissions } from "../../Permissions/index.js";

// eslint-disable-next-line import/no-unresolved
import { Store__System } from "@talentbait/shared-components";
import { withTranslation } from "react-i18next";
import { t } from "i18next";

function hasChannel(channelShortName, selectedChannels) {
  if (!channelShortName) {
    return false;
  }
  selectedChannels = selectedChannels || [];

  return selectedChannels.includes(channelShortName);
}
class CampaignRead extends Reflux.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingCampaigns: false,
      isLoadingAdset: false,
      isLoadingCampaignMetrics: false,
      toggleFade: true,
      heightY: 0, // This is used the position sticky feature
      isCampaignActionsOpen: false,
      showModal: false,
      showFBAdComments: false,
      error: undefined,
      errorCurrentView: false,
      socialCommentsCount: undefined,
      showLocationChange: false,
      newLocations: undefined,
      creatives: [],
      adset: undefined
    };

    this.stores = [Store__System, StatusStore];

    logger.debug("AdsetRead:constructor", "Adset Constructor", { props: this.props });

    // If the campaign data wasn"t loaded yet, load it.
    if (!this.state.adset && !this.state.isLoadingAdset) {
      this.setState({
        isLoadingAdset: true
      });
      Actions.loadAdset(this.props.match.params.adsetId);
    }

    // If the metrics for this campaign wasn"t loaded yet, load it.
    if (!this.state.campaignMetrics && !this.state.isLoadingCampaignMetrics) {
      this.setState({
        isLoadingCampaignMetrics: true
      });
    }
    this.loadHandlerFailed = Actions.loadAdset.failed.listen((err) => {
      logger.log("error:AdsetRead:loadAdset:failed", "called...", err);

      Actions.addNotification("Kampagne konnte nicht geladen werden", "error");

      this.setState({
        isLoadingAdset: false,
        errorCurrentView: true
      });
    });
    // Register handler
    this.loadHandler = Actions.loadAdset.completed.listen((adset) => {
      this.setState({
        isLoadingAdset: false,
        adset: adset
      });

      logger.debug("AdsetRead:loadAdset:completed", "called...", adset);
    });

    // Register handler
    this.loadAdsets = Actions.loadAdsets.completed.listen((adsets) => {
      logger.debug("AdsetRead:loadAdsets", "called...", adsets);
      this.setState({
        adsets: adsets
      });
    });
    // Register handler
    this.loadAdsets = Actions.loadAdsets.failed.listen((err) => {
      logger.debug("AdsetRead:loadAdsets", "called...", err);
    });

    Actions.loadAdsets(this.props.match.params.campaignId);
  }

  componentWillUpdate(nextProps) {
    const { adsetId, campaignId } = this.props.match.params;
    const { adsetId: nextAdsetId } = nextProps.match.params;
    const { isLoadingAdset } = this.state;

    logger.debug(
      "AdsetRead:componentWillUpdate",
      "called...",

      {
        adsetId,
        nextAdsetId
      }
    );

    if (campaignId && adsetId !== nextAdsetId && !isLoadingAdset) {
      this.setState({
        isLoadingAdset: true
      });

      Actions.loadAdset(nextAdsetId);
    }
  }

  renderImages() {
    const { campaignData } = this.state;
    return _.map(campaignData.images, function (src) {
      return (
        <div className="campaign-read__photo">
          {" "}
          <img src={src} />{" "}
        </div>
      );
    });
  }

  renderDate() {
    const { t } = this.props;
    const { campaignData } = this.state;
    const date1 = new Date(campaignData.createdDate);
    date1.setDate(date1.getDate() + 30);

    const date2 = new Date();
    const timeDiff = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return t("{{days}} days remaining", { days: diffDays });
  }

  remainingDays(startDate) {
    const { adset } = this.state;
    return remainingDaysString(adset, startDate);
  }

  renderStatus() {
    const { adset } = this.state;
    return renderStatus(adset.status);
  }

  renderLocations(locs) {
    return locs.map((location) => {
      return (
        <span>
          • {location} <br />
        </span>
      );
    });
  }

  renderChart() {
    const { campaignMetrics } = this.state;
    return <CampaignChart data={(campaignMetrics && campaignMetrics.dailyClicksArr) || []} />;
  }

  handleScroll(event) {
    const scrollTop = event.target.scrollTop;
    this.setState({
      heightY: scrollTop
    });
  }

  renderActionButtons() {
    return null;
  }

  toggleMenu() {
    this.setState({
      isCampaignActionsOpen: !this.state.isCampaignActionsOpen
    });
  }

  openAdmin() {
    const { id: tbCampaignId, orgaId } = this.props.match.params;
    window.location.href = `${window.baseUrlInteralTools}/admin-campaign/${orgaId}/${tbCampaignId}`;
  }

  openATS(e) {
    e.preventDefault();
    Actions.toggleAtsView();
  }

  copyCapaign(e) {
    e.preventDefault();
    const { id: tbCampaignId } = this.props.match.params;
    const { userProfile } = this.state;

    // Copy campaign
    Actions.toggleModal("showCopyCampaignModal", true, {
      campaignId: tbCampaignId,
      userName: userProfile && userProfile.userName,
      userId: userProfile.userId
    });

    this.setState({
      isCampaignActionsOpen: false
    });
  }

  renderMenu(hasPermissionsToReadCampaignStats) {
    const { userProfile } = this.state;
    const { orgaId } = this.props.match.params;
    const { t } = this.props;

    logger.debug("Campaign_Read:renderMenu", "called...", {
      orgaId
    });

    if (!hasPermissionsToReadCampaignStats) {
      return;
    }

    return (
      <div className="campaign-read__actions">
        <a
          href="#"
          className="button button--dropdown button--ghost transition"
          onClick={this.toggleMenu.bind(this)}
        >
          {t("Edit")} <span>▼</span>
        </a>
        {userProfile && userProfile.superRank === "admin" && (
          <a
            href="#"
            className="button button--dropdown button--ghost transition"
            onClick={this.openAdmin.bind(this)}
          >
            {t("Open admin")}
          </a>
        )}
      </div>
    );
  }

  showFBCommentsPopup() {
    logger.debug("Campaign_Read:showFBCommentsPopup", "called:");

    this.setState({
      showFBAdComments: true
    });
  }

  closeFBCommentsPopup() {
    this.setState({
      showFBAdComments: false
    });
  }

  createReport(e) {
    e.preventDefault();
    logger.debug("Campaign_Read:createReport", "campaignData:", this.state.adset);
    Actions.createReport(this.props.match.params.adsetId, this.state.adset);
  }

  getClicks(adset) {
    const metrics = (adset && adset.metrics) || {};
    return sumValueFromDictKey(metrics, "totalClicks");
  }

  getImpressions(adset) {
    const metrics = (adset && adset.metrics) || {};
    return sumValueFromDictKey(metrics, "totalImpressions");
  }

  downloadPdf(e) {
    e.preventDefault();
    logger.debug("Campaign_Read:downloadPdf", "called...", this.props.match.params.adsetId);

    const ref = Actions.downloadPdf.completed.listen((pdf) => {
      logger.debug("Campaign_Read:downloadPdf", "pdf ready:", typeof pdf);
      const newBlob = new Blob([pdf], { type: "application/pdf" });
      const data = window.URL.createObjectURL(newBlob);

      // Fix for IE
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob, "report.pdf");
      } else {
        window.open(data);
      }

      ref();
    });

    Actions.downloadPdf(this.props.match.params.adsetId);

    Actions.notifiyEvent({
      eventName: "reporting",
      text: `📊 A Report was downloaded for *${this.state.adset.name}*/${this.state.adset.companyName} from *${this.state.user.displayName}*`
    });
  }

  renderJobCategory(catId) {
    return getJobCategoryName(catId) || "-";
  }

  onChangeLocation(locs) {
    logger.log("AdsetRead:onChangeLocation", "called", locs);
  }

  renderBasicData() {
    const { t } = this.props;
    const { adset = {} } = this.state;
    const { name, locations, link, userName, channels } = adset;

    logger.log("AdsetRead:renderBasicData", "called", adset);

    return (
      <div className="campaign-read__social campaign-read__infos">
        <table className="campaign-read__table">
          <tr>
            <td className="table__head">{t("Campaign")}</td>
            <td>{name}</td>
          </tr>
          <tr>
            <td className="table__head">{t("Advertising group name")}</td>
            <td>{name}</td>
          </tr>
          <tr>
            <td className="table__head">{t("Locations")}</td>
            <td>
              {locations.map((item) => {
                return (
                  <span className="campaign-read__social-container-custom__loc-item">
                    📍 {item.location + ", " + item.country} <br />
                  </span>
                );
              })}
            </td>
          </tr>
          <tr>
            <td className="table__head">{t("Landing page")}</td>
            <td>
              <a
                target="_blank"
                className="campaign-read__social-container-custom__label-url"
                href={link}
                rel="noreferrer"
              >
                {link}
              </a>
            </td>
          </tr>
          <tr>
            <td className="table__head">{t("Created by")}</td>
            <td>👤{userName}</td>
          </tr>
          {channels && (
            <tr>
              <td className="table__head">{t("Channels")}</td>
              <td>
                <ul className="table__head-ul channel-list">
                  {channels.map((channel) => {
                    return <li>{channel}</li>;
                  })}
                </ul>
              </td>
            </tr>
          )}
        </table>
      </div>
    );
  }

  sumValueByChannel(channelName, metric, data) {
    var sum = 0;
    const metrics = data || {};
    for (const localChannelName in metrics) {
      var channel = metrics[localChannelName];
      if (channel && channel.platform && channel.platform === channelName && channel[metric]) {
        sum += parseInt(channel[metric], 10);
      }
    }
    return sum;
  }

  _renderStatsByChannel(channelName, labelLikes = "Likes") {
    const {
      userProfile,
      adset: { metrics }
    } = this.state;
    const { t } = this.props;

    return (
      <div className="campaign-read__social campaign-read__facebook">
        <div className="campaign-read__social-container">
          <ul>
            <li className="center">
              <svg width="25" height="21" viewBox="0 0 25 21" xmlns="http://www.w3.org/2000/svg">
                <g fillRule="nonzero" fill="none">
                  <path
                    d="M14.5715 7.217C17.125353 8.4080376 19.3366854 10.2253308 21 12.5c-.7608 1.3994-5.7234 6.5-11.4438 6.5-.7042382-.0021261-1.40648707-.0748904-2.0962-.2172 1.568347.7761235 3.2903016 1.1919892 5.04 1.2172 5.72 0 10.683-5.1006 11.4438-6.5-2.2965446-3.1224421-5.6115253-5.34473797-9.3723-6.283z"
                    className="icon icon__shade"
                  />
                  <path
                    d="M12.5 6C5.5964 6 0 12.6211 0 13.5c0 .8789 5.5964 7.5 12.5 7.5S25 14.4375 25 13.5 19.4036 6 12.5 6zm0 14c-5.9141 0-10.6543-5.2236-11.429-6.5C1.8457 12.2236 6.5859 7 12.5 7c5.72 0 10.683 5.1011 11.4438 6.5C23.183 14.8994 18.22 20 12.5 20z"
                    className="icon__line"
                  />
                  <path
                    d="M12.5 10C10.5670034 10 9 11.5670034 9 13.5s1.5670034 3.5 3.5 3.5 3.5-1.5670034 3.5-3.5-1.5670034-3.5-3.5-3.5zm0 6c-1.3807119 0-2.5-1.1192881-2.5-2.5s1.1192881-2.5 2.5-2.5 2.5 1.1192881 2.5 2.5c-.0015981 1.3800494-1.1199506 2.4984019-2.5 2.5zM7.0671 5.4819c.08951188.15479166.25479053.25008608.4336.25.0878507.0002139.1741622-.02305568.25-.0674.11488718-.0661556.19874795-.1752856.23309502-.3033321.03434708-.12804648.01636033-.26449598-.04999502-.3792679l-1-1.7314c-.1380712-.23919452-.44390547-.32117117-.6831-.1831-.2391945.1380712-.32117118.44390548-.1831.6831l.9995 1.7314zM17.25 5.6646c.0758378.04434432.1621493.0676139.25.0674.1788095.00008608.3440881-.09520834.4336-.25l1-1.7314c.1380712-.23919452.0560945-.5450288-.1831-.68309997-.2391945-.13807118-.5450288-.05609454-.6831.18309997l-1 1.7314c-.0663968.11471126-.0844597.25111513-.0502084.37915442.0342514.12803928.1180061.2372063.2328084.30344558zM12.5 4c.2761424 0 .5-.22385763.5-.5v-3c0-.27614237-.2238576-.5-.5-.5s-.5.22385763-.5.5v3c0 .27614237.2238576.5.5.5z"
                    className="icon__line"
                  />
                </g>
              </svg>
              <h3>{t("Impressions")}</h3>
              <span>
                {formatIntlNumber(
                  this.sumValueByChannel(channelName, "totalImpressions", metrics),
                  { language: userProfile?.language }
                )}
              </span>
            </li>
            <li className="center">
              <svg width="19" height="25" viewBox="0 0 19 25" xmlns="http://www.w3.org/2000/svg">
                <g fillRule="nonzero" fill="none">
                  <path
                    d="M15.9082 2.93c-.3771737-.40650236-.8084849-.75917614-1.2818-1.0481.6606822 1.07714946.9599315 2.33721314.8541 3.5964l-.88 11C14.3367295 19.5893922 11.7422172 21.9848638 8.62 22H6.38c-1.10291817-.0013317-2.18371724-.3094884-3.1215-.89C4.3481332 22.8971759 6.2868635 23.9911778 8.38 24h2.24c3.1223005-.0149206 5.7170179-2.4103348 5.9809-5.5215l.88-11c.1413621-1.67019666-.4298815-3.3223246-1.5727-4.5485z"
                    className="icon icon__shade"
                  />
                  <path
                    d="M11.5 0h-4C5.54654417.00008826 3.68198818.81644436 2.35692698 2.2517849S.36685376 5.61086278.5226 7.5581l.88 11C1.6935653 22.1959309 4.73055147 24.9998351 8.38 25h2.24c3.6495638-.0000085 6.6867255-2.8039542 6.9777-6.4419l.88-11c.1557504-1.94728924-.5093014-3.8710748-1.8344287-5.3064253C15.3181439.8163242 13.453508.00000453 11.5 0zm5.9809 7.4785l-.88 11C16.3370179 21.5896652 13.7423005 23.9850794 10.62 24H8.38c-3.12230048-.0149206-5.71701793-2.4103348-5.9809-5.5215l-.88-11c-.13353836-1.66912882.4364909-3.31812483 1.57232178-4.54845476C4.22725265 1.6997153 5.82553784.99999704 7.5 1h4c1.6744622-.00000296 3.2727473.6997153 4.4085782 1.93004524C17.0444091 4.16037517 17.6144384 5.80937118 17.4809 7.4785z"
                    className="icon__line"
                  />
                  <path
                    d="M9.5 3c-.27614237 0-.5.22385763-.5.5v2c0 .27614237.22385763.5.5.5.27614237 0 .5-.22385763.5-.5v-2c0-.27614237-.22385763-.5-.5-.5z"
                    className="icon icon__line"
                  />
                </g>
              </svg>
              <h3>{t("Clicks")}</h3>
              <span>
                {formatIntlNumber(this.sumValueByChannel(channelName, "totalClicks", metrics), {
                  language: userProfile?.language
                })}
              </span>
            </li>
            <li className="center">
              <svg width="24" height="17" viewBox="0 0 24 17" xmlns="http://www.w3.org/2000/svg">
                <g fillRule="nonzero" fill="none">
                  <path
                    d="M7 1c-.3380331.0043894-.6741077.05211198-1 .142C7.7646282 1.59057524 8.99998165 3.1792495 8.99998165 5S7.7646282 8.40942476 6 8.858c.3258923.08988802.6619669.1376106 1 .142 2.20913898-e-8 3.9999999-1.79086102 3.9999999-4S9.20913898 1.00000003 7 1z"
                    className="icon icon__shade"
                  />
                  <path
                    d="M9.3207 9.4038c2.0382607-1.0680504 3.0843656-3.38933634 2.5344028-5.6237891C11.30514 1.5455581 9.30113848-.02500928 7-.02500928S2.69486003 1.5455581 2.1448972 3.7800109C1.59493438 6.01446365 2.64103932 8.3357496 4.6793 9.4038 1.8338799 10.6123166-.01000735 13.4085881 0 16.5c0 .2761424.22385763.5.5.5.27614238 0 .5-.2238576.5-.5C1 13.1914 3.6914 10 7 10s6 3.1914 6 6.5c0 .2761424.2238576.5.5.5s.5-.2238576.5-.5c.0100074-3.0914119-1.8338799-5.8876834-4.6793-7.0962zM3 5c0-2.209139 1.790861-4 4-4s4 1.790861 4 4-1.790861 4-4 4c-2.20808814-.00253493-3.99746507-1.79191186-4-4z"
                    className="icon icon__line"
                  />
                  <path
                    d="M19.64 7.3694c1.5044965-.95237362 2.1983247-2.78456633 1.7020507-4.49460648-.4962741-1.71004014-2.0631477-2.8861502-3.8437443-2.8851506-1.7805966.00099962-3.3461487 1.1788682-3.8405024 2.88946447-.4943538 1.71059626.2015311 3.5420088 1.707096 4.4926926-1.3192749.45949902-2.4562826 1.33021874-3.2438 2.4841.2603097.2201984.5064029.4566723.7368.708 1.3058727-2.07056892 3.8240114-3.02751072 6.1754301-2.3467838C21.3847488 8.8978431 23.0022273 11.0520306 23 13.5c0 .2761424.2238576.5.5.5s.5-.2238576.5-.5c-.0047608-2.7618179-1.7527359-5.2196473-4.36-6.1306zM14.5 4c0-1.65685425 1.3431458-3 3-3s3 1.34314575 3 3-1.3431458 3-3 3c-1.6560775-.0018737-2.9981263-1.3439225-3-3z"
                    className="icon icon__line"
                  />
                  <path
                    d="M17.5 1c-.341459.0033925-.6797659.06574247-1 .1843 1.1976858.41766735 2.0000848 1.54727683 2.0000848 2.8157 0 1.26842317-.802399 2.39803265-2.0000848 2.8157.3202341.11855753.658541.1809075 1 .1843 1.6568542 0 3-1.34314575 3-3s-1.3431458-3-3-3z"
                    className="icon icon__shade"
                  />
                </g>
              </svg>
              <h3>
                {t("Interactions")}
                <img
                  src="/images/info.svg"
                  data-tip="Bei Interaktionen mit dem Beitrag werden alle Handlungen berücksichtigt, die Personen bei deinen Werbeanzeigen während ihrer Schaltung vornehmen. Interaktionen mit dem Beitrag können z. B. folgende Handlungen umfassen: Reagieren auf die Werbeanzeige, Kommentieren oder Teilen der Werbeanzeige, Beanspruchen eines Angebots, Aufrufen eines Fotos oder Videos oder Klicken auf einen Link."
                  className="campaign-read__info"
                  alt=""
                />{" "}
              </h3>
              <span>
                {formatIntlNumber(
                  this.sumValueByChannel(channelName, "totalInteractions", metrics),
                  { language: userProfile?.language }
                )}
              </span>
            </li>
            <li className="center" onClick={this.showFBCommentsPopup.bind(this)}>
              <svg width="25" height="23" viewBox="0 0 25 23" xmlns="http://www.w3.org/2000/svg">
                <g fillRule="nonzero" fill="none">
                  <path
                    d="M3 6v8c0 1.1045695.8954305 2 2 2h8.3335L16 18h2.3333l-4-3H5.5c-.82842712 0-1.5-.6715729-1.5-1.5V5H1.5c-.2759825.00038557-.49961443.2240175-.5.5V6h2zM23.5 1.002H22V12.5c0 .2761424-.2238576.5-.5.5H18v3.5l2 1.5v-4h3.5c.2761424 0 .5-.2238576.5-.5V1.502c0-.27614237-.2238576-.5-.5-.5z"
                    className="icon icon__shade"
                  />
                  <path
                    d="M19.5 5h-10c-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5h10c.2761424 0 .5-.22385763.5-.5 0-.27614237-.2238576-.5-.5-.5zM19.5 9h-10c-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5h10c.2761424 0 .5-.22385763.5-.5 0-.27614237-.2238576-.5-.5-.5z"
                    className="icon icon__line"
                  />
                  <path
                    d="M23.5.002h-18c-.82842712 0-1.5.67157287-1.5 1.5V4H1.5C.67157287 4 0 4.67157288 0 5.5v11.998c0 .8284271.67157287 1.5 1.5 1.5H4v3c-.00029424.2662533.10550862.5216511.2940033.7096954.18849468.1880443.44414488.2932358.7103967.2923046.2152383-.0003533.42443645-.0711983.5956-.2017l5.0664-3.8c.3636 0 8.7112.021 9.07-.0378.0841241.0255254.1713148.0395527.2592.0417.2662865.0009314.5219672-.1042876.7104676-.2923752C20.8945681 18.5217372 21.0003475 18.2662879 21 18v-3h2.5c.8284271 0 1.5-.6715729 1.5-1.5V1.502c0-.82842713-.6715729-1.5-1.5-1.5zM10.3306 18l-.2642.1982L5 21.998V18H4l-2.5-.002c-.27614237 0-.5-.2238576-.5-.5V5.5c.00038557-.2759825.2240175-.49961443.5-.5H4v8.5c0 .8284271.67157288 1.5 1.5 1.5h8.8335l4 3h-8.0029zM24 13.5c0 .2761424-.2238576.5-.5.5H20v4l-5.0662-3.8-.2668-.2H5.5c-.27614237 0-.5-.2238576-.5-.5V1.502c0-.27614237.22385763-.5.5-.5h18c.2761424 0 .5.22385763.5.5V13.5z"
                    className="icon icon__line"
                  />
                </g>
              </svg>
              <h3>{t("Comments")}</h3>

              <span>
                {formatIntlNumber(this.sumValueByChannel(channelName, "totalComments", metrics), {
                  language: userProfile?.language
                })}
              </span>
            </li>
            <li className="center">
              <svg width="23" height="24" viewBox="0 0 23 24" xmlns="http://www.w3.org/2000/svg">
                <g fillRule="nonzero" fill="none">
                  <path
                    d="M21.7153 9.0176c-.1856486-.19529425-.4431469-.30608426-.7126-.3066-.0739969.0002071-.147756.00838767-.22.0244-.2715.06-.5516.1171-.8344.1728-.1144517 3.2123876-.5200128 6.4077756-1.2117 9.5469-.2120966.9076667-1.023089 1.5484718-1.9552 1.5449H6.2564l-1.233-.613-.002 1.0046L8.2564 22h10.525c.9320737.0035251 1.7430118-.6372699 1.9551-1.5449.7712191-3.5154781 1.1942618-7.0983781 1.263-10.6968.0104251-.27535612-.092263-.5429884-.2842-.7407z"
                    className="icon icon__shade"
                  />
                  <path
                    d="M21.0028 7.7109c-.1465353.0002154-.2926177.0162754-.4357.0479C17.8284 8.3623 14.22 8.77 14.22 8.77c-.0654262.01310642-.1319742.01980475-.1987.02-.5518739-.0009907-.9990093-.44812613-1-1V2.08c-.0006096-.5523645-.2206614-1.08185454-.6117296-1.47194754C12.0185021.21795946 11.4884643-.0007696 10.9361 0 9.9047794-.0052865 9.01543304.72354 8.818 1.7358c-.5518 2.9048-2.2091 7.0357-3.9888 8.0435-.2608652-.4790963-.7621894-.77785133-1.3077-.7793h-2c-.82842713 0-1.5.67157288-1.5 1.5v12c0 .8284271.67157288 1.5 1.5 1.5h2c.82842712 0 1.5-.6715729 1.5-1.5v-.9917l3 1.4917h10.76c1.3952839.0020284 2.6083238-.9568468 2.9285-2.3149.7865541-3.5801936 1.2182749-7.2292036 1.2889-10.8941.0191187-.5427666-.1822835-1.0701582-.5583217-1.46202086-.3760382-.39186268-.8946849-.61482102-1.4377783-.61807914zM4.0215 22.5c0 .2761424-.22385763.5-.5.5h-2c-.27614237 0-.5-.2238576-.5-.5v-12c.00044048-.2759597.22404028-.4995595.5-.5h2c.27595972.0004405.49955952.2240403.5.5L4 21l.0215.0107V22.5zm16.715-2.0449c-.2120882.9076301-1.0230263 1.5484251-1.9551 1.5449H8.2564l-3.2349-1.6084.0188-9.604C7.5542 9.666 9.3008 4.5522 9.8 1.9224c.10847638-.5401429.585193-.9271893 1.1361-.9224.5975046-.00066487 1.0827703.48249813 1.0847 1.08v5.7086c.0014324 1.10397565.8960244 1.99856762 2 2 .1157725-.00025937.2313164-.01029503.3454-.03.4008-.0459 3.77-.4409 6.4162-1.0239.072244-.01601233.1460031-.0241929.22-.0244.2694531.00051574.5269514.11130575.7126.3066.1919005.19772817.2945517.46535843.2841.7407-.0685609 3.598643-.4914698 7.1817796-1.2626 10.6975z"
                    className="icon icon__line"
                  />
                </g>
              </svg>
              <h3>{labelLikes}</h3>
              <span>
                {formatIntlNumber(this.sumValueByChannel(channelName, "totalLikes", metrics), {
                  language: userProfile?.language
                })}
              </span>
            </li>
            <li className="center">
              <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
                <g fillRule="nonzero" fill="none">
                  <path
                    d="M21.264 8.0666C20.1934 10.526 18.001 13 15 13c-1.027478.0144523-2.040669-.2417252-2.9378-.7428C12.3585 13.0373 13.9149 14 16 14c3.5128 0 5.9231-3.39 6.7158-6.178-.4748388.12850008-.96107.21042058-1.4518.2446zM11.5 20c-.5068517.0031308-1.0094573.0926813-1.4862.2648C11.6427684 20.8346964 12.8026793 22.2855367 13 24h2.9724c-.2575514-2.2762103-2.181667-3.99709-4.4724-4zM7.6261 10.3833c-1.65514642-.1355722-3.1800764-.95107917-4.2118-2.2524-1.0227918-1.2680957-1.47431235-2.90335968-1.2471-4.5166.0262-.19.056-.3623.0853-.5374-.1926629-.1947929-.36849064-.4055453-.5256-.63-.28259063.84979082-.4802241 1.72550803-.59 2.6143-.22729407 1.6131041.22404002 3.248276 1.2466 4.5164 1.0317236 1.3013208 2.55665358 2.1168278 4.2118 2.2524.8646.0747 1.6591.125 2.3739.15-.0303213-.5066445-.09187156-1.0109358-.1843-1.51-.3715-.0235-.7558-.0518-1.1588-.0867z"
                    className="icon icon__shade"
                  />
                  <path
                    d="M16 15c4.9166 0 8-5.5833 8-9-1.0520001.84362217-2.3929203 1.24097574-3.7347 1.1067-1.4037 0-2.8876-.1992-4.0979-.1992-.391186-.00625208-.7820799.02472075-1.1674.0925-2.3817271.45582825-4.0781077 2.57630394-4 5v7.0251c-2.83150093.2577685-4.9995056 2.6316902-5 5.4749v.5h11v-.5c-.0004944-2.8432098-2.1684991-5.2171315-5-5.4749v-5.2927c1.1572492.8517143 2.5634211 1.2973301 4 1.2676zm-.8073-7.0188c.3218594-.05516344.6482053-.07983943.9747-.0737.5471 0 1.1692.0444 1.8278.0916.7407.053 1.5066.1077 2.27.1077.8259977.01666985 1.6504237-.07910837 2.4506-.2847C21.9231 10.61 19.5128 14 16 14c-2.32 0-4-1.1946-4-2-.068827-1.9424477 1.2850067-3.6465812 3.1927-4.0188zM15.9724 24H7.0276c.25353896-2.278644 2.17969403-4.0023674 4.4724-4.0023674 2.292706 0 4.218861 1.7237234 4.4724 4.0023674z"
                    className="icon icon__line"
                  />
                  <path
                    d="M10 13c0-9.9583-8-8.2083-8-13C.9641 1.0359.42 2.9365.1459 4.9246c-.2530854 1.90074555.28445723 3.82211338 1.48714316 5.3155766C2.8357291 11.7336398 4.59830043 12.6684921 6.5093 12.8265 7.7054 12.93 8.9172 13 10 13zM2.3835 9.5776C1.36074374 8.30948858.90925985 6.67422622 1.1365 5.061c.1097759-.88879197.30740937-1.76450918.59-2.6143.73051264.9147621 1.63374017 1.67698244 2.6583 2.2433 2.1173 1.365 4.302 2.7734 4.5845 7.2905-.7148-.0254-1.5093-.0757-2.3739-.15-1.65526162-.1356699-3.1802457-.9513675-4.2119-2.2529z"
                    className="icon icon__line"
                  />
                </g>
              </svg>
              <h3>{t("Shares")}</h3>
              {formatIntlNumber(this.sumValueByChannel(channelName, "totalShares", metrics), {
                language: userProfile?.language
              })}
            </li>
          </ul>
        </div>
        <div className="campaign-read__social-preview"></div>
      </div>
    );
  }

  renderFacebookStats() {
    return this._renderStatsByChannel("facebook");
  }

  renderInstagramStats() {
    logger.debug("AdsetRead:renderInstagramStats", "called...", this.state.adset);
    return this._renderStatsByChannel("instagram", "Hearts");
  }

  // eslint-disable-next-line no-dupe-class-members
  renderImages() {
    const { pictures } = this.state.adset;
    return pictures.map((src) => {
      return (
        <div className="campaign-read__photo">
          <a href={src.image_url} target="_blank" rel="noreferrer">
            <img src={src.image_url} />
          </a>
        </div>
      );
    });
  }

  renderScheduledDate(startDate) {
    startDate += "";
    if (startDate.indexOf("-") !== -1) {
      return moment(startDate, "YYYY-MM-DD").format("DD.MM.YYYY");
    }
    return moment(startDate, "DD.MM.YYYY").format("DD.MM.YYYY");
  }

  renderDateSection() {
    const { t } = this.props;
    const { status = "ACTIVE", startDate } = this.state.adset;

    return (
      <div className="campaign-read__days-left">
        {status === "ACTIVE" && (
          <strong title={moment(startDate).format("DD.MM.YY")}>
            {moment(startDate).lang("de").fromNow()} gestartet
          </strong>
        )}

        {status === "SCHEDULED" && (
          <strong>
            {t("Scheduled on:")} {this.renderScheduledDate(startDate)}
          </strong>
        )}

        {status === "FINISHED" && t("Completed")}
        <br />
      </div>
    );
  }

  renderTopMetricSection() {
    const { userProfile, adset } = this.state;
    const { lifeTimeBudget, campaignGoal, applicantsCount, minClicks } = adset;

    return (
      <div className="campaign-read__metrics">
        <div className="campaign-read__metrics-budget">
          <svg width="24" height="23" viewBox="0 0 24 23" xmlns="http://www.w3.org/2000/svg">
            <g fillRule="nonzero" fill="none">
              <path
                d="M21 19.5557c0 .2761424-.2238576.5-.5.5H1V21.5c0 .2761424.22385763.5.5.5h21c.2761424 0 .5-.2238576.5-.5V17h-2v2.5557zM3.5 1H21v2H5c-1.1045695 0-2 .8954305-2 2 .0020702.3427797.09318095.67913832.2644.9761C1.93608586 5.8538677.9392738 4.70780695 1.00235964 3.37537333 1.06544546 2.0429397 2.16607924.99618528 3.5 1zM22.5 7H21v5h2V7.5c0-.27614237-.2238576-.5-.5-.5z"
                className="icon icon__shade"
              />
              <path
                d="M22.5 6H22V1c0-.55228475-.4477153-1-1-1H3.5C1.56700338 0 0 1.56700338 0 3.5v18c0 .8284271.67157287 1.5 1.5 1.5h21c.8284271 0 1.5-.6715729 1.5-1.5v-14c0-.82842712-.6715729-1.5-1.5-1.5zM4 5c.00060624-.55203344.44796656-.99939376 1-1h16v2H5c-.55203344-.00060624-.99939376-.44796656-1-1zm-.5-4H21v2H5c-1.1045695 0-2 .8954305-2 2 .0020702.3427797.09318095.67913832.2644.9761C1.93608586 5.8538677.9392738 4.70780695 1.00235964 3.37537333 1.06544546 2.0429397 2.16607924.99618528 3.5 1zM23 16h-4v-3h4v3zm-4-4c-.5522847 0-1 .4477153-1 1v3c0 .5522847.4477153 1 1 1h4v4.5c0 .2761424-.2238576.5-.5.5h-21c-.27614237 0-.5-.2238576-.5-.5V5.9443C1.6564904 6.6194917 2.55826575 7.0002934 3.5 7h19c.2761424 0 .5.22385763.5.5V12h-4z"
                className="icon icon__line"
              />
            </g>
          </svg>
          <h2>{t("Budget")}</h2>
          <span className="indicator indicator--success">-</span>
          <span className="campaign-read__metrics-budget__nr">€{lifeTimeBudget}</span>
        </div>
        {campaignGoal == "applicants" && (
          <div className="campaign-read__metrics-reach">
            <svg width="24" height="17" viewBox="0 0 24 17" xmlns="http://www.w3.org/2000/svg">
              <g fillRule="nonzero" fill="none">
                <path className="icon icon__shade" d="M23 8h-3.323l-.6-1.5.6-1.5H23" />
                <path
                  d="M23 4h-3.323c-.4089355.0000053-.7766623.2489981-.9285.6287L18.2 6h-1.59C15.2813764 1.77751186 10.9225358-.70706657 6.61231734.3012307 2.30209886 1.309528-.50229616 5.4698152.1799987 9.8435002c.68229487 4.373685 4.62060892 7.4821096 9.03313933 7.1296581C13.6256685 16.6207067 17.0206242 12.9265361 17 8.5c0-.1689-.0156-.3335-.0253-.5h-1c.0111.166.0254.3313.0254.5.0127339 3.9087662-2.9695482 7.1763586-6.86321696 7.5198103-3.89366872.3434516-7.4019045-2.351627-8.0736101-6.20226683C.39156734 5.9669037 2.78010917 2.24319115 6.5600972 1.2480501 10.3400852.25290908 14.2525622 2.31777974 15.564 6h-2.1827c-1.2801783-2.4581348-4.19594577-3.57110966-6.78845164-2.5912135-2.59250587.97989614-4.04312855 3.7432468-3.37732074 6.4335968.66580782 2.69035 3.2378076 4.458182 5.9880962 4.1158434C11.9539124 13.6158881 14.0140461 11.2714772 14 8.5c0-.1687-.01-.335-.0251-.5h-1.0254c.026308.1655733.0431686.33251006.0505.5 0 2.4852814-2.0147186 4.5-4.5 4.5C6.01471863 13 4 10.9852814 4 8.5 4 6.01471863 6.01471863 4 8.5 4c1.49244145.00400216 2.8838128.75477583 3.7065 2H8.5c-1.05681014.00038835-1.99917152.66538207-2.3537203 1.6609437-.35454877.99556166-.0446561 2.10651987.77401377 2.7748218.81866986.6683019 1.9691773.7495071 2.8736032.2028247C10.6983226 10.0919079 11.1611928 9.03549283 10.95 8H9.908c.0591763.1601402.09029882.3292844.092.5 0 .60669337-.36546327 1.1536478-.92597485 1.3858193-.5605116.2321715-1.20568833.10383787-1.63468532-.32515913-.428997-.428997-.55733063-1.07417373-.32515913-1.63468532C7.3463522 7.36546327 7.89330663 7 8.5 7h9.7l.5486 1.3713c.1518242.37966803.519501.6286538.9284.6287H23c.5522847 0 1-.44771525 1-1V5c0-.55228475-.4477153-1-1-1zm0 4h-3.323l-.6-1.5.6-1.5H23v3z"
                  className="icon icon__line"
                />
              </g>
            </svg>
            <h2>{t("Applicants")}</h2>
            <span className="indicator indicator--success">
              {userProfile.organizationId == "3rL8QwAUpXjkBqdTrueK" && (
                <a
                  style={{ color: "blue", textDecoration: "underline", marginTop: 2 }}
                  href={window.config.baseUrlMessenger}
                >
                  zu den Bewerben
                </a>
              )}
            </span>
            <span className="campaign-read__metrics-budget__nr">{applicantsCount || 0}</span>
          </div>
        )}
        {campaignGoal == "traffic" && (
          <div className="campaign-read__metrics-reach">
            <svg width="24" height="17" viewBox="0 0 24 17" xmlns="http://www.w3.org/2000/svg">
              <g fillRule="nonzero" fill="none">
                <path className="icon icon__shade" d="M23 8h-3.323l-.6-1.5.6-1.5H23" />
                <path
                  d="M23 4h-3.323c-.4089355.0000053-.7766623.2489981-.9285.6287L18.2 6h-1.59C15.2813764 1.77751186 10.9225358-.70706657 6.61231734.3012307 2.30209886 1.309528-.50229616 5.4698152.1799987 9.8435002c.68229487 4.373685 4.62060892 7.4821096 9.03313933 7.1296581C13.6256685 16.6207067 17.0206242 12.9265361 17 8.5c0-.1689-.0156-.3335-.0253-.5h-1c.0111.166.0254.3313.0254.5.0127339 3.9087662-2.9695482 7.1763586-6.86321696 7.5198103-3.89366872.3434516-7.4019045-2.351627-8.0736101-6.20226683C.39156734 5.9669037 2.78010917 2.24319115 6.5600972 1.2480501 10.3400852.25290908 14.2525622 2.31777974 15.564 6h-2.1827c-1.2801783-2.4581348-4.19594577-3.57110966-6.78845164-2.5912135-2.59250587.97989614-4.04312855 3.7432468-3.37732074 6.4335968.66580782 2.69035 3.2378076 4.458182 5.9880962 4.1158434C11.9539124 13.6158881 14.0140461 11.2714772 14 8.5c0-.1687-.01-.335-.0251-.5h-1.0254c.026308.1655733.0431686.33251006.0505.5 0 2.4852814-2.0147186 4.5-4.5 4.5C6.01471863 13 4 10.9852814 4 8.5 4 6.01471863 6.01471863 4 8.5 4c1.49244145.00400216 2.8838128.75477583 3.7065 2H8.5c-1.05681014.00038835-1.99917152.66538207-2.3537203 1.6609437-.35454877.99556166-.0446561 2.10651987.77401377 2.7748218.81866986.6683019 1.9691773.7495071 2.8736032.2028247C10.6983226 10.0919079 11.1611928 9.03549283 10.95 8H9.908c.0591763.1601402.09029882.3292844.092.5 0 .60669337-.36546327 1.1536478-.92597485 1.3858193-.5605116.2321715-1.20568833.10383787-1.63468532-.32515913-.428997-.428997-.55733063-1.07417373-.32515913-1.63468532C7.3463522 7.36546327 7.89330663 7 8.5 7h9.7l.5486 1.3713c.1518242.37966803.519501.6286538.9284.6287H23c.5522847 0 1-.44771525 1-1V5c0-.55228475-.4477153-1-1-1zm0 4h-3.323l-.6-1.5.6-1.5H23v3z"
                  className="icon icon__line"
                />
              </g>
            </svg>
            <h2>{t("Impressions")}</h2>
            <span className="indicator indicator--success"></span>
            <span className="campaign-read__metrics-budget__nr">
              {formatIntlNumber(this.getImpressions(adset), { language: userProfile?.language })}
            </span>
          </div>
        )}
        <div className="campaign-read__metrics-talents">
          <svg width="24" height="17" viewBox="0 0 24 17" xmlns="http://www.w3.org/2000/svg">
            <g fillRule="nonzero" fill="none">
              <path
                d="M7 1c-.3380331.0043894-.6741077.05211198-1 .142C7.7646282 1.59057524 8.99998165 3.1792495 8.99998165 5S7.7646282 8.40942476 6 8.858c.3258923.08988802.6619669.1376106 1 .142 2.20913898-e-8 3.9999999-1.79086102 3.9999999-4S9.20913898 1.00000003 7 1z"
                className="icon icon__shade"
              />
              <path
                d="M9.3207 9.4038c2.0382607-1.0680504 3.0843656-3.38933634 2.5344028-5.6237891C11.30514 1.5455581 9.30113848-.02500928 7-.02500928S2.69486003 1.5455581 2.1448972 3.7800109C1.59493438 6.01446365 2.64103932 8.3357496 4.6793 9.4038 1.8338799 10.6123166-.01000735 13.4085881 0 16.5c0 .2761424.22385763.5.5.5.27614238 0 .5-.2238576.5-.5C1 13.1914 3.6914 10 7 10s6 3.1914 6 6.5c0 .2761424.2238576.5.5.5s.5-.2238576.5-.5c.0100074-3.0914119-1.8338799-5.8876834-4.6793-7.0962zM3 5c0-2.209139 1.790861-4 4-4s4 1.790861 4 4-1.790861 4-4 4c-2.20808814-.00253493-3.99746507-1.79191186-4-4z"
                className="icon__line"
              />
              <path
                d="M19.64 7.3694c1.5044965-.95237362 2.1983247-2.78456633 1.7020507-4.49460648-.4962741-1.71004014-2.0631477-2.8861502-3.8437443-2.8851506-1.7805966.00099962-3.3461487 1.1788682-3.8405024 2.88946447-.4943538 1.71059626.2015311 3.5420088 1.707096 4.4926926-1.3192749.45949902-2.4562826 1.33021874-3.2438 2.4841.2603097.2201984.5064029.4566723.7368.708 1.3058727-2.07056892 3.8240114-3.02751072 6.1754301-2.3467838C21.3847488 8.8978431 23.0022273 11.0520306 23 13.5c0 .2761424.2238576.5.5.5s.5-.2238576.5-.5c-.0047608-2.7618179-1.7527359-5.2196473-4.36-6.1306zM14.5 4c0-1.65685425 1.3431458-3 3-3s3 1.34314575 3 3-1.3431458 3-3 3c-1.6560775-.0018737-2.9981263-1.3439225-3-3z"
                className="icon__line"
              />
              <path
                d="M17.5 1c-.341459.0033925-.6797659.06574247-1 .1843 1.1976858.41766735 2.0000848 1.54727683 2.0000848 2.8157 0 1.26842317-.802399 2.39803265-2.0000848 2.8157.3202341.11855753.658541.1809075 1 .1843 1.6568542 0 3-1.34314575 3-3s-1.3431458-3-3-3z"
                className="icon icon__shade"
              />
            </g>
          </svg>
          <h2>{t("Clicks")}</h2>
          <span className="indicator">Mindestklicks {minClicks}</span>
          <span className="campaign-read__metrics-budget__nr">
            {formatIntlNumber(this.getClicks(adset), { language: userProfile?.language })}
          </span>
        </div>
      </div>
    );
  }

  renderFBComments(comments) {
    logger.debug("AdsetRead:renderFBComments", "called...", comments);

    return _.map(comments, (comment) => {
      return (
        <div className="fb-comment-wrapper">
          <span className="fb-comment-user">{comment.from}</span>
          <span className="fb-comment">
            {" "}
            {comment.message} <br />
          </span>
        </div>
      );
    });
  }

  renderOtherMetrics() {
    const { adset, userProfile } = this.state;

    if (!adset) {
      return;
    }
    const metric = (adset.metrics && adset.metrics) || {};

    return (
      <div className="campaign-read__social-container">
        <ul>
          {[
            { name: "Indeed", channel: "indeed", hasImpressions: true },
            { name: "Reddit", channel: "reddit", hasImpressions: true },
            { name: "LinkedIn", channel: "linkedin", hasImpressions: true },
            { name: "Snapchat", channel: "snapchat", hasImpressions: true },
            { name: "Spotify", channel: "spotify", hasImpressions: true },
            { name: "Xing", channel: "xing", hasImpressions: false },
            { name: "Pinterest", channel: "pinterest", hasImpressions: true },
            { name: "Google Search", channel: "google-search", hasImpressions: true },
            { name: "Kleinanzeigen", channel: "ebay-kleinanzeigen", hasImpressions: true }
          ]
            .filter((channel) => {
              return hasChannel(channel.channel, adset.channels);
            })
            .map((item) => {
              const totalClicks = getSumByChannelAndMetricField(
                metric,
                item.channel,
                "totalClicks"
              );
              const totalImpressions = getSumByChannelAndMetricField(
                metric,
                item.channel,
                "totalImpressions"
              );

              return (
                <li className="center">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fillRule="nonzero" fill="none">
                      <path
                        d="M21.264 8.0666C20.1934 10.526 18.001 13 15 13c-1.027478.0144523-2.040669-.2417252-2.9378-.7428C12.3585 13.0373 13.9149 14 16 14c3.5128 0 5.9231-3.39 6.7158-6.178-.4748388.12850008-.96107.21042058-1.4518.2446zM11.5 20c-.5068517.0031308-1.0094573.0926813-1.4862.2648C11.6427684 20.8346964 12.8026793 22.2855367 13 24h2.9724c-.2575514-2.2762103-2.181667-3.99709-4.4724-4zM7.6261 10.3833c-1.65514642-.1355722-3.1800764-.95107917-4.2118-2.2524-1.0227918-1.2680957-1.47431235-2.90335968-1.2471-4.5166.0262-.19.056-.3623.0853-.5374-.1926629-.1947929-.36849064-.4055453-.5256-.63-.28259063.84979082-.4802241 1.72550803-.59 2.6143-.22729407 1.6131041.22404002 3.248276 1.2466 4.5164 1.0317236 1.3013208 2.55665358 2.1168278 4.2118 2.2524.8646.0747 1.6591.125 2.3739.15-.0303213-.5066445-.09187156-1.0109358-.1843-1.51-.3715-.0235-.7558-.0518-1.1588-.0867z"
                        className="icon icon__shade"
                      />
                      <path
                        d="M16 15c4.9166 0 8-5.5833 8-9-1.0520001.84362217-2.3929203 1.24097574-3.7347 1.1067-1.4037 0-2.8876-.1992-4.0979-.1992-.391186-.00625208-.7820799.02472075-1.1674.0925-2.3817271.45582825-4.0781077 2.57630394-4 5v7.0251c-2.83150093.2577685-4.9995056 2.6316902-5 5.4749v.5h11v-.5c-.0004944-2.8432098-2.1684991-5.2171315-5-5.4749v-5.2927c1.1572492.8517143 2.5634211 1.2973301 4 1.2676zm-.8073-7.0188c.3218594-.05516344.6482053-.07983943.9747-.0737.5471 0 1.1692.0444 1.8278.0916.7407.053 1.5066.1077 2.27.1077.8259977.01666985 1.6504237-.07910837 2.4506-.2847C21.9231 10.61 19.5128 14 16 14c-2.32 0-4-1.1946-4-2-.068827-1.9424477 1.2850067-3.6465812 3.1927-4.0188zM15.9724 24H7.0276c.25353896-2.278644 2.17969403-4.0023674 4.4724-4.0023674 2.292706 0 4.218861 1.7237234 4.4724 4.0023674z"
                        className="icon icon__line"
                      />
                      <path
                        d="M10 13c0-9.9583-8-8.2083-8-13C.9641 1.0359.42 2.9365.1459 4.9246c-.2530854 1.90074555.28445723 3.82211338 1.48714316 5.3155766C2.8357291 11.7336398 4.59830043 12.6684921 6.5093 12.8265 7.7054 12.93 8.9172 13 10 13zM2.3835 9.5776C1.36074374 8.30948858.90925985 6.67422622 1.1365 5.061c.1097759-.88879197.30740937-1.76450918.59-2.6143.73051264.9147621 1.63374017 1.67698244 2.6583 2.2433 2.1173 1.365 4.302 2.7734 4.5845 7.2905-.7148-.0254-1.5093-.0757-2.3739-.15-1.65526162-.1356699-3.1802457-.9513675-4.2119-2.2529z"
                        className="icon icon__line"
                      />
                    </g>
                  </svg>
                  <h3>{item.name}</h3>
                  <span>
                    {formatIntlNumber(totalClicks, { language: userProfile?.language })} Klicks
                  </span>
                  {item.hasImpressions && (
                    <span style={{ fontSize: 13 }}>{totalImpressions || 0} Impr.</span>
                  )}{" "}
                  <br />
                </li>
              );
            })}
        </ul>
      </div>
    );
  }

  getSumByChannelAndMetricField(metric, channelName, field) {
    var sum = _.toPairs(metric);

    sum = _.filter(sum, (channel) => {
      return channel[1].platform == channelName;
    });

    sum = _.reduce(
      sum,
      (sum, item) => {
        return sum + parseInt(item[1][field], 10);
      },
      0
    );

    return sum;
  }

  renderTwitterMetrics() {
    const {
      adset: { metrics },
      userProfile
    } = this.state;

    const totalImpressions = getSumByChannelAndMetricField(metrics, "twitter", "totalImpressions");
    const totalClicks = getSumByChannelAndMetricField(metrics, "twitter", "totalClicks");
    const totalLikes = getSumByChannelAndMetricField(metrics, "twitter", "totalLikes");
    const totalRetweets = getSumByChannelAndMetricField(metrics, "twitter", "totalRetweets");
    const totalComments = getSumByChannelAndMetricField(metrics, "twitter", "totalComments");

    var ctr;

    try {
      ctr = ((totalClicks / totalImpressions) * 100).toFixed(2);
    } catch (error) {
      ctr = 0;
    }

    logger.debug("AdsetRead:renderTwitterMetrics", "mapped...", {
      totalClicks,
      totalImpressions,
      ctrReal: totalClicks / totalImpressions,
      ctr
    });

    return (
      <div className="campaign-read__social-container">
        <ul>
          <li className="center">
            <svg width="25" height="21" viewBox="0 0 25 21" xmlns="http://www.w3.org/2000/svg">
              <g fillRule="nonzero" fill="none">
                <path
                  d="M14.5715 7.217C17.125353 8.4080376 19.3366854 10.2253308 21 12.5c-.7608 1.3994-5.7234 6.5-11.4438 6.5-.7042382-.0021261-1.40648707-.0748904-2.0962-.2172 1.568347.7761235 3.2903016 1.1919892 5.04 1.2172 5.72 0 10.683-5.1006 11.4438-6.5-2.2965446-3.1224421-5.6115253-5.34473797-9.3723-6.283z"
                  className="icon icon__shade"
                />
                <path
                  d="M12.5 6C5.5964 6 0 12.6211 0 13.5c0 .8789 5.5964 7.5 12.5 7.5S25 14.4375 25 13.5 19.4036 6 12.5 6zm0 14c-5.9141 0-10.6543-5.2236-11.429-6.5C1.8457 12.2236 6.5859 7 12.5 7c5.72 0 10.683 5.1011 11.4438 6.5C23.183 14.8994 18.22 20 12.5 20z"
                  className="icon__line"
                />
                <path
                  d="M12.5 10C10.5670034 10 9 11.5670034 9 13.5s1.5670034 3.5 3.5 3.5 3.5-1.5670034 3.5-3.5-1.5670034-3.5-3.5-3.5zm0 6c-1.3807119 0-2.5-1.1192881-2.5-2.5s1.1192881-2.5 2.5-2.5 2.5 1.1192881 2.5 2.5c-.0015981 1.3800494-1.1199506 2.4984019-2.5 2.5zM7.0671 5.4819c.08951188.15479166.25479053.25008608.4336.25.0878507.0002139.1741622-.02305568.25-.0674.11488718-.0661556.19874795-.1752856.23309502-.3033321.03434708-.12804648.01636033-.26449598-.04999502-.3792679l-1-1.7314c-.1380712-.23919452-.44390547-.32117117-.6831-.1831-.2391945.1380712-.32117118.44390548-.1831.6831l.9995 1.7314zM17.25 5.6646c.0758378.04434432.1621493.0676139.25.0674.1788095.00008608.3440881-.09520834.4336-.25l1-1.7314c.1380712-.23919452.0560945-.5450288-.1831-.68309997-.2391945-.13807118-.5450288-.05609454-.6831.18309997l-1 1.7314c-.0663968.11471126-.0844597.25111513-.0502084.37915442.0342514.12803928.1180061.2372063.2328084.30344558zM12.5 4c.2761424 0 .5-.22385763.5-.5v-3c0-.27614237-.2238576-.5-.5-.5s-.5.22385763-.5.5v3c0 .27614237.2238576.5.5.5z"
                  className="icon__line"
                />
              </g>
            </svg>
            <h3>{t("Impressions")}</h3>
            <span>{formatIntlNumber(totalImpressions, { language: userProfile?.language })}</span>
          </li>
          <li className="center">
            <svg width="19" height="25" viewBox="0 0 19 25" xmlns="http://www.w3.org/2000/svg">
              <g fillRule="nonzero" fill="none">
                <path
                  d="M15.9082 2.93c-.3771737-.40650236-.8084849-.75917614-1.2818-1.0481.6606822 1.07714946.9599315 2.33721314.8541 3.5964l-.88 11C14.3367295 19.5893922 11.7422172 21.9848638 8.62 22H6.38c-1.10291817-.0013317-2.18371724-.3094884-3.1215-.89C4.3481332 22.8971759 6.2868635 23.9911778 8.38 24h2.24c3.1223005-.0149206 5.7170179-2.4103348 5.9809-5.5215l.88-11c.1413621-1.67019666-.4298815-3.3223246-1.5727-4.5485z"
                  className="icon icon__shade"
                />
                <path
                  d="M11.5 0h-4C5.54654417.00008826 3.68198818.81644436 2.35692698 2.2517849S.36685376 5.61086278.5226 7.5581l.88 11C1.6935653 22.1959309 4.73055147 24.9998351 8.38 25h2.24c3.6495638-.0000085 6.6867255-2.8039542 6.9777-6.4419l.88-11c.1557504-1.94728924-.5093014-3.8710748-1.8344287-5.3064253C15.3181439.8163242 13.453508.00000453 11.5 0zm5.9809 7.4785l-.88 11C16.3370179 21.5896652 13.7423005 23.9850794 10.62 24H8.38c-3.12230048-.0149206-5.71701793-2.4103348-5.9809-5.5215l-.88-11c-.13353836-1.66912882.4364909-3.31812483 1.57232178-4.54845476C4.22725265 1.6997153 5.82553784.99999704 7.5 1h4c1.6744622-.00000296 3.2727473.6997153 4.4085782 1.93004524C17.0444091 4.16037517 17.6144384 5.80937118 17.4809 7.4785z"
                  className="icon__line"
                />
                <path
                  d="M9.5 3c-.27614237 0-.5.22385763-.5.5v2c0 .27614237.22385763.5.5.5.27614237 0 .5-.22385763.5-.5v-2c0-.27614237-.22385763-.5-.5-.5z"
                  className="icon icon__line"
                />
              </g>
            </svg>
            <h3>{t("Clicks")}</h3>
            <span>{formatIntlNumber(totalClicks, { language: userProfile?.language })}</span>
          </li>
          <li className="center">
            <svg width="24" height="17" viewBox="0 0 24 17" xmlns="http://www.w3.org/2000/svg">
              <g fillRule="nonzero" fill="none">
                <path
                  d="M7 1c-.3380331.0043894-.6741077.05211198-1 .142C7.7646282 1.59057524 8.99998165 3.1792495 8.99998165 5S7.7646282 8.40942476 6 8.858c.3258923.08988802.6619669.1376106 1 .142 2.20913898-e-8 3.9999999-1.79086102 3.9999999-4S9.20913898 1.00000003 7 1z"
                  className="icon icon__shade"
                />
                <path
                  d="M9.3207 9.4038c2.0382607-1.0680504 3.0843656-3.38933634 2.5344028-5.6237891C11.30514 1.5455581 9.30113848-.02500928 7-.02500928S2.69486003 1.5455581 2.1448972 3.7800109C1.59493438 6.01446365 2.64103932 8.3357496 4.6793 9.4038 1.8338799 10.6123166-.01000735 13.4085881 0 16.5c0 .2761424.22385763.5.5.5.27614238 0 .5-.2238576.5-.5C1 13.1914 3.6914 10 7 10s6 3.1914 6 6.5c0 .2761424.2238576.5.5.5s.5-.2238576.5-.5c.0100074-3.0914119-1.8338799-5.8876834-4.6793-7.0962zM3 5c0-2.209139 1.790861-4 4-4s4 1.790861 4 4-1.790861 4-4 4c-2.20808814-.00253493-3.99746507-1.79191186-4-4z"
                  className="icon icon__line"
                />
                <path
                  d="M19.64 7.3694c1.5044965-.95237362 2.1983247-2.78456633 1.7020507-4.49460648-.4962741-1.71004014-2.0631477-2.8861502-3.8437443-2.8851506-1.7805966.00099962-3.3461487 1.1788682-3.8405024 2.88946447-.4943538 1.71059626.2015311 3.5420088 1.707096 4.4926926-1.3192749.45949902-2.4562826 1.33021874-3.2438 2.4841.2603097.2201984.5064029.4566723.7368.708 1.3058727-2.07056892 3.8240114-3.02751072 6.1754301-2.3467838C21.3847488 8.8978431 23.0022273 11.0520306 23 13.5c0 .2761424.2238576.5.5.5s.5-.2238576.5-.5c-.0047608-2.7618179-1.7527359-5.2196473-4.36-6.1306zM14.5 4c0-1.65685425 1.3431458-3 3-3s3 1.34314575 3 3-1.3431458 3-3 3c-1.6560775-.0018737-2.9981263-1.3439225-3-3z"
                  className="icon icon__line"
                />
                <path
                  d="M17.5 1c-.341459.0033925-.6797659.06574247-1 .1843 1.1976858.41766735 2.0000848 1.54727683 2.0000848 2.8157 0 1.26842317-.802399 2.39803265-2.0000848 2.8157.3202341.11855753.658541.1809075 1 .1843 1.6568542 0 3-1.34314575 3-3s-1.3431458-3-3-3z"
                  className="icon icon__shade"
                />
              </g>
            </svg>
            <h3>CTR</h3>
            <span>{ctr}%</span>
          </li>
          <li className="center">
            <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
              <g fillRule="nonzero" fill="none">
                <path
                  d="M21.264 8.0666C20.1934 10.526 18.001 13 15 13c-1.027478.0144523-2.040669-.2417252-2.9378-.7428C12.3585 13.0373 13.9149 14 16 14c3.5128 0 5.9231-3.39 6.7158-6.178-.4748388.12850008-.96107.21042058-1.4518.2446zM11.5 20c-.5068517.0031308-1.0094573.0926813-1.4862.2648C11.6427684 20.8346964 12.8026793 22.2855367 13 24h2.9724c-.2575514-2.2762103-2.181667-3.99709-4.4724-4zM7.6261 10.3833c-1.65514642-.1355722-3.1800764-.95107917-4.2118-2.2524-1.0227918-1.2680957-1.47431235-2.90335968-1.2471-4.5166.0262-.19.056-.3623.0853-.5374-.1926629-.1947929-.36849064-.4055453-.5256-.63-.28259063.84979082-.4802241 1.72550803-.59 2.6143-.22729407 1.6131041.22404002 3.248276 1.2466 4.5164 1.0317236 1.3013208 2.55665358 2.1168278 4.2118 2.2524.8646.0747 1.6591.125 2.3739.15-.0303213-.5066445-.09187156-1.0109358-.1843-1.51-.3715-.0235-.7558-.0518-1.1588-.0867z"
                  className="icon icon__shade"
                />
                <path
                  d="M16 15c4.9166 0 8-5.5833 8-9-1.0520001.84362217-2.3929203 1.24097574-3.7347 1.1067-1.4037 0-2.8876-.1992-4.0979-.1992-.391186-.00625208-.7820799.02472075-1.1674.0925-2.3817271.45582825-4.0781077 2.57630394-4 5v7.0251c-2.83150093.2577685-4.9995056 2.6316902-5 5.4749v.5h11v-.5c-.0004944-2.8432098-2.1684991-5.2171315-5-5.4749v-5.2927c1.1572492.8517143 2.5634211 1.2973301 4 1.2676zm-.8073-7.0188c.3218594-.05516344.6482053-.07983943.9747-.0737.5471 0 1.1692.0444 1.8278.0916.7407.053 1.5066.1077 2.27.1077.8259977.01666985 1.6504237-.07910837 2.4506-.2847C21.9231 10.61 19.5128 14 16 14c-2.32 0-4-1.1946-4-2-.068827-1.9424477 1.2850067-3.6465812 3.1927-4.0188zM15.9724 24H7.0276c.25353896-2.278644 2.17969403-4.0023674 4.4724-4.0023674 2.292706 0 4.218861 1.7237234 4.4724 4.0023674z"
                  className="icon icon__line"
                />
                <path
                  d="M10 13c0-9.9583-8-8.2083-8-13C.9641 1.0359.42 2.9365.1459 4.9246c-.2530854 1.90074555.28445723 3.82211338 1.48714316 5.3155766C2.8357291 11.7336398 4.59830043 12.6684921 6.5093 12.8265 7.7054 12.93 8.9172 13 10 13zM2.3835 9.5776C1.36074374 8.30948858.90925985 6.67422622 1.1365 5.061c.1097759-.88879197.30740937-1.76450918.59-2.6143.73051264.9147621 1.63374017 1.67698244 2.6583 2.2433 2.1173 1.365 4.302 2.7734 4.5845 7.2905-.7148-.0254-1.5093-.0757-2.3739-.15-1.65526162-.1356699-3.1802457-.9513675-4.2119-2.2529z"
                  className="icon icon__line"
                />
              </g>
            </svg>
            <h3>Retweets</h3>
            <span>{totalRetweets || 0}</span>
          </li>
          <li className="center">
            <svg width="23" height="24" viewBox="0 0 23 24" xmlns="http://www.w3.org/2000/svg">
              <g fillRule="nonzero" fill="none">
                <path
                  d="M21.7153 9.0176c-.1856486-.19529425-.4431469-.30608426-.7126-.3066-.0739969.0002071-.147756.00838767-.22.0244-.2715.06-.5516.1171-.8344.1728-.1144517 3.2123876-.5200128 6.4077756-1.2117 9.5469-.2120966.9076667-1.023089 1.5484718-1.9552 1.5449H6.2564l-1.233-.613-.002 1.0046L8.2564 22h10.525c.9320737.0035251 1.7430118-.6372699 1.9551-1.5449.7712191-3.5154781 1.1942618-7.0983781 1.263-10.6968.0104251-.27535612-.092263-.5429884-.2842-.7407z"
                  className="icon icon__shade"
                />
                <path
                  d="M21.0028 7.7109c-.1465353.0002154-.2926177.0162754-.4357.0479C17.8284 8.3623 14.22 8.77 14.22 8.77c-.0654262.01310642-.1319742.01980475-.1987.02-.5518739-.0009907-.9990093-.44812613-1-1V2.08c-.0006096-.5523645-.2206614-1.08185454-.6117296-1.47194754C12.0185021.21795946 11.4884643-.0007696 10.9361 0 9.9047794-.0052865 9.01543304.72354 8.818 1.7358c-.5518 2.9048-2.2091 7.0357-3.9888 8.0435-.2608652-.4790963-.7621894-.77785133-1.3077-.7793h-2c-.82842713 0-1.5.67157288-1.5 1.5v12c0 .8284271.67157288 1.5 1.5 1.5h2c.82842712 0 1.5-.6715729 1.5-1.5v-.9917l3 1.4917h10.76c1.3952839.0020284 2.6083238-.9568468 2.9285-2.3149.7865541-3.5801936 1.2182749-7.2292036 1.2889-10.8941.0191187-.5427666-.1822835-1.0701582-.5583217-1.46202086-.3760382-.39186268-.8946849-.61482102-1.4377783-.61807914zM4.0215 22.5c0 .2761424-.22385763.5-.5.5h-2c-.27614237 0-.5-.2238576-.5-.5v-12c.00044048-.2759597.22404028-.4995595.5-.5h2c.27595972.0004405.49955952.2240403.5.5L4 21l.0215.0107V22.5zm16.715-2.0449c-.2120882.9076301-1.0230263 1.5484251-1.9551 1.5449H8.2564l-3.2349-1.6084.0188-9.604C7.5542 9.666 9.3008 4.5522 9.8 1.9224c.10847638-.5401429.585193-.9271893 1.1361-.9224.5975046-.00066487 1.0827703.48249813 1.0847 1.08v5.7086c.0014324 1.10397565.8960244 1.99856762 2 2 .1157725-.00025937.2313164-.01029503.3454-.03.4008-.0459 3.77-.4409 6.4162-1.0239.072244-.01601233.1460031-.0241929.22-.0244.2694531.00051574.5269514.11130575.7126.3066.1919005.19772817.2945517.46535843.2841.7407-.0685609 3.598643-.4914698 7.1817796-1.2626 10.6975z"
                  className="icon icon__line"
                />
              </g>
            </svg>
            <h3>Favs/Likes</h3>
            <span>{totalLikes || 0}</span>
          </li>
          <li className="center">
            <svg width="25" height="23" viewBox="0 0 25 23" xmlns="http://www.w3.org/2000/svg">
              <g fillRule="nonzero" fill="none">
                <path
                  d="M3 6v8c0 1.1045695.8954305 2 2 2h8.3335L16 18h2.3333l-4-3H5.5c-.82842712 0-1.5-.6715729-1.5-1.5V5H1.5c-.2759825.00038557-.49961443.2240175-.5.5V6h2zM23.5 1.002H22V12.5c0 .2761424-.2238576.5-.5.5H18v3.5l2 1.5v-4h3.5c.2761424 0 .5-.2238576.5-.5V1.502c0-.27614237-.2238576-.5-.5-.5z"
                  className="icon icon__shade"
                />
                <path
                  d="M19.5 5h-10c-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5h10c.2761424 0 .5-.22385763.5-.5 0-.27614237-.2238576-.5-.5-.5zM19.5 9h-10c-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5h10c.2761424 0 .5-.22385763.5-.5 0-.27614237-.2238576-.5-.5-.5z"
                  className="icon icon__line"
                />
                <path
                  d="M23.5.002h-18c-.82842712 0-1.5.67157287-1.5 1.5V4H1.5C.67157287 4 0 4.67157288 0 5.5v11.998c0 .8284271.67157287 1.5 1.5 1.5H4v3c-.00029424.2662533.10550862.5216511.2940033.7096954.18849468.1880443.44414488.2932358.7103967.2923046.2152383-.0003533.42443645-.0711983.5956-.2017l5.0664-3.8c.3636 0 8.7112.021 9.07-.0378.0841241.0255254.1713148.0395527.2592.0417.2662865.0009314.5219672-.1042876.7104676-.2923752C20.8945681 18.5217372 21.0003475 18.2662879 21 18v-3h2.5c.8284271 0 1.5-.6715729 1.5-1.5V1.502c0-.82842713-.6715729-1.5-1.5-1.5zM10.3306 18l-.2642.1982L5 21.998V18H4l-2.5-.002c-.27614237 0-.5-.2238576-.5-.5V5.5c.00038557-.2759825.2240175-.49961443.5-.5H4v8.5c0 .8284271.67157288 1.5 1.5 1.5h8.8335l4 3h-8.0029zM24 13.5c0 .2761424-.2238576.5-.5.5H20v4l-5.0662-3.8-.2668-.2H5.5c-.27614237 0-.5-.2238576-.5-.5V1.502c0-.27614237.22385763-.5.5-.5h18c.2761424 0 .5.22385763.5.5V13.5z"
                  className="icon icon__line"
                />
              </g>
            </svg>
            <h3>{t("Comments")}</h3>
            <span>{totalComments || 0}</span>
          </li>
        </ul>
      </div>
    );
  }

  renderGoogleMetrics(channelName) {
    const { t } = this.props;
    const {
      adset: { metrics },
      userProfile
    } = this.state;

    const totalImpressions = getSumByChannelAndMetricField(
      metrics,
      channelName,
      "totalImpressions"
    );
    const totalClicks = getSumByChannelAndMetricField(metrics, channelName, "totalClicks");

    var ctr;

    try {
      ctr = ((totalClicks / totalImpressions) * 100).toFixed(2);
    } catch (error) {
      ctr = 0;
    }

    logger.debug("AdsetRead:renderGoogleMetrics", "mapped...", {
      totalClicks,
      totalImpressions,
      ctrReal: totalClicks / totalImpressions,
      ctr
    });

    return (
      <div className="campaign-read__social-container">
        <ul>
          <li className="center">
            <svg width="25" height="21" viewBox="0 0 25 21" xmlns="http://www.w3.org/2000/svg">
              <g fillRule="nonzero" fill="none">
                <path
                  d="M14.5715 7.217C17.125353 8.4080376 19.3366854 10.2253308 21 12.5c-.7608 1.3994-5.7234 6.5-11.4438 6.5-.7042382-.0021261-1.40648707-.0748904-2.0962-.2172 1.568347.7761235 3.2903016 1.1919892 5.04 1.2172 5.72 0 10.683-5.1006 11.4438-6.5-2.2965446-3.1224421-5.6115253-5.34473797-9.3723-6.283z"
                  className="icon icon__shade"
                />
                <path
                  d="M12.5 6C5.5964 6 0 12.6211 0 13.5c0 .8789 5.5964 7.5 12.5 7.5S25 14.4375 25 13.5 19.4036 6 12.5 6zm0 14c-5.9141 0-10.6543-5.2236-11.429-6.5C1.8457 12.2236 6.5859 7 12.5 7c5.72 0 10.683 5.1011 11.4438 6.5C23.183 14.8994 18.22 20 12.5 20z"
                  className="icon__line"
                />
                <path
                  d="M12.5 10C10.5670034 10 9 11.5670034 9 13.5s1.5670034 3.5 3.5 3.5 3.5-1.5670034 3.5-3.5-1.5670034-3.5-3.5-3.5zm0 6c-1.3807119 0-2.5-1.1192881-2.5-2.5s1.1192881-2.5 2.5-2.5 2.5 1.1192881 2.5 2.5c-.0015981 1.3800494-1.1199506 2.4984019-2.5 2.5zM7.0671 5.4819c.08951188.15479166.25479053.25008608.4336.25.0878507.0002139.1741622-.02305568.25-.0674.11488718-.0661556.19874795-.1752856.23309502-.3033321.03434708-.12804648.01636033-.26449598-.04999502-.3792679l-1-1.7314c-.1380712-.23919452-.44390547-.32117117-.6831-.1831-.2391945.1380712-.32117118.44390548-.1831.6831l.9995 1.7314zM17.25 5.6646c.0758378.04434432.1621493.0676139.25.0674.1788095.00008608.3440881-.09520834.4336-.25l1-1.7314c.1380712-.23919452.0560945-.5450288-.1831-.68309997-.2391945-.13807118-.5450288-.05609454-.6831.18309997l-1 1.7314c-.0663968.11471126-.0844597.25111513-.0502084.37915442.0342514.12803928.1180061.2372063.2328084.30344558zM12.5 4c.2761424 0 .5-.22385763.5-.5v-3c0-.27614237-.2238576-.5-.5-.5s-.5.22385763-.5.5v3c0 .27614237.2238576.5.5.5z"
                  className="icon__line"
                />
              </g>
            </svg>
            <h3>{t("Impressions")}</h3>
            <span>{formatIntlNumber(totalImpressions, { language: userProfile?.language })}</span>
          </li>
          <li className="center">
            <svg width="19" height="25" viewBox="0 0 19 25" xmlns="http://www.w3.org/2000/svg">
              <g fillRule="nonzero" fill="none">
                <path
                  d="M15.9082 2.93c-.3771737-.40650236-.8084849-.75917614-1.2818-1.0481.6606822 1.07714946.9599315 2.33721314.8541 3.5964l-.88 11C14.3367295 19.5893922 11.7422172 21.9848638 8.62 22H6.38c-1.10291817-.0013317-2.18371724-.3094884-3.1215-.89C4.3481332 22.8971759 6.2868635 23.9911778 8.38 24h2.24c3.1223005-.0149206 5.7170179-2.4103348 5.9809-5.5215l.88-11c.1413621-1.67019666-.4298815-3.3223246-1.5727-4.5485z"
                  className="icon icon__shade"
                />
                <path
                  d="M11.5 0h-4C5.54654417.00008826 3.68198818.81644436 2.35692698 2.2517849S.36685376 5.61086278.5226 7.5581l.88 11C1.6935653 22.1959309 4.73055147 24.9998351 8.38 25h2.24c3.6495638-.0000085 6.6867255-2.8039542 6.9777-6.4419l.88-11c.1557504-1.94728924-.5093014-3.8710748-1.8344287-5.3064253C15.3181439.8163242 13.453508.00000453 11.5 0zm5.9809 7.4785l-.88 11C16.3370179 21.5896652 13.7423005 23.9850794 10.62 24H8.38c-3.12230048-.0149206-5.71701793-2.4103348-5.9809-5.5215l-.88-11c-.13353836-1.66912882.4364909-3.31812483 1.57232178-4.54845476C4.22725265 1.6997153 5.82553784.99999704 7.5 1h4c1.6744622-.00000296 3.2727473.6997153 4.4085782 1.93004524C17.0444091 4.16037517 17.6144384 5.80937118 17.4809 7.4785z"
                  className="icon__line"
                />
                <path
                  d="M9.5 3c-.27614237 0-.5.22385763-.5.5v2c0 .27614237.22385763.5.5.5.27614237 0 .5-.22385763.5-.5v-2c0-.27614237-.22385763-.5-.5-.5z"
                  className="icon icon__line"
                />
              </g>
            </svg>
            <h3>{t("Clicks")}</h3>
            <span>{formatIntlNumber(totalClicks, { language: userProfile?.language })}</span>
          </li>
          <li className="center">
            <svg width="24" height="17" viewBox="0 0 24 17" xmlns="http://www.w3.org/2000/svg">
              <g fillRule="nonzero" fill="none">
                <path
                  d="M7 1c-.3380331.0043894-.6741077.05211198-1 .142C7.7646282 1.59057524 8.99998165 3.1792495 8.99998165 5S7.7646282 8.40942476 6 8.858c.3258923.08988802.6619669.1376106 1 .142 2.20913898-e-8 3.9999999-1.79086102 3.9999999-4S9.20913898 1.00000003 7 1z"
                  className="icon icon__shade"
                />
                <path
                  d="M9.3207 9.4038c2.0382607-1.0680504 3.0843656-3.38933634 2.5344028-5.6237891C11.30514 1.5455581 9.30113848-.02500928 7-.02500928S2.69486003 1.5455581 2.1448972 3.7800109C1.59493438 6.01446365 2.64103932 8.3357496 4.6793 9.4038 1.8338799 10.6123166-.01000735 13.4085881 0 16.5c0 .2761424.22385763.5.5.5.27614238 0 .5-.2238576.5-.5C1 13.1914 3.6914 10 7 10s6 3.1914 6 6.5c0 .2761424.2238576.5.5.5s.5-.2238576.5-.5c.0100074-3.0914119-1.8338799-5.8876834-4.6793-7.0962zM3 5c0-2.209139 1.790861-4 4-4s4 1.790861 4 4-1.790861 4-4 4c-2.20808814-.00253493-3.99746507-1.79191186-4-4z"
                  className="icon icon__line"
                />
                <path
                  d="M19.64 7.3694c1.5044965-.95237362 2.1983247-2.78456633 1.7020507-4.49460648-.4962741-1.71004014-2.0631477-2.8861502-3.8437443-2.8851506-1.7805966.00099962-3.3461487 1.1788682-3.8405024 2.88946447-.4943538 1.71059626.2015311 3.5420088 1.707096 4.4926926-1.3192749.45949902-2.4562826 1.33021874-3.2438 2.4841.2603097.2201984.5064029.4566723.7368.708 1.3058727-2.07056892 3.8240114-3.02751072 6.1754301-2.3467838C21.3847488 8.8978431 23.0022273 11.0520306 23 13.5c0 .2761424.2238576.5.5.5s.5-.2238576.5-.5c-.0047608-2.7618179-1.7527359-5.2196473-4.36-6.1306zM14.5 4c0-1.65685425 1.3431458-3 3-3s3 1.34314575 3 3-1.3431458 3-3 3c-1.6560775-.0018737-2.9981263-1.3439225-3-3z"
                  className="icon icon__line"
                />
                <path
                  d="M17.5 1c-.341459.0033925-.6797659.06574247-1 .1843 1.1976858.41766735 2.0000848 1.54727683 2.0000848 2.8157 0 1.26842317-.802399 2.39803265-2.0000848 2.8157.3202341.11855753.658541.1809075 1 .1843 1.6568542 0 3-1.34314575 3-3s-1.3431458-3-3-3z"
                  className="icon icon__shade"
                />
              </g>
            </svg>
            <h3>CTR</h3>
            <span>{ctr}%</span>
          </li>
        </ul>
      </div>
    );
  }

  changeVisibility(value) {
    this.setState({
      showModal: value
    });
  }

  render() {
    const { t } = this.props;
    const { orgaId, id: tbCampaignId } = this.props.match.params;

    const {
      userProfile,
      campaignDataError,
      isLoadingAdset,
      showModal,
      heightY,
      adset,
      adsets,
      organization
    } = this.state;

    if (campaignDataError === "No user found") {
      var href = window.location.href.replace("http://", "").replace("https://", "").split("/");
      logger.debug("AdPreviewTool:render", "called...", href);
      href = href.slice(1).join("/");
      return <Redirect to={"/login?url=/" + href} />;
    }

    const { hasPermissionsToReadCampaign } = getPermissions(userProfile);

    if (!hasPermissionsToReadCampaign) {
      return <Redirect to="/" />;
    }

    if (!userProfile) {
      return <LoadingView msg={t("Loading user data")} showSpinner />;
    }

    if (!adset) {
      return <LoadingView msg={t("Loading advertising group")} showSpinner />;
    }

    // Add two fields to make the array sortable by date and stauts.
    var sortedArrayAdsets = _.map(adsets, function (el) {
      el.dateSorted = new Date(el.createdDate);
      el.statusSort = renderStatusSort(el.status);
      return el;
    });

    const {
      previews,
      name,
      channels,
      status,
      campaignManager,
      companyName,
      lastStatus,
      hasNewPreviewFlow
    } = adset;

    logger.debug(
      "AdsetRead:render",
      "called...",
      _.intersection(channels, [
        "ebay-kleinanzeigen",
        "pinterest",
        "linkedin",
        "indeed",
        "xing",
        "google-search",
        "snapchat",
        "spotify"
      ])
    );

    if (adset && (status === "IN_PROGRESS" || status === "WAITING_FOR_APPROVAL")) {
      return (
        <CampaignInProgress
          hasNewPreviewFlow={hasNewPreviewFlow}
          status={status}
          campaignId={tbCampaignId}
          orgaId={orgaId}
          sortedArrayAdsets={sortedArrayAdsets}
          adset={adset}
          userProfile={userProfile}
        />
      );
    }

    const campaignMiddleSectionStyles = classNames({
      "campaign-read__container": true,
      "fade-in": !isLoadingAdset
    });

    var disclaimer = <div></div>;

    return (
      <div>
        <AdsetLeftSidebar adsets={sortedArrayAdsets} isAdmin={false} />
        <div className="campaign-read__wrapper" onScroll={this.handleScroll.bind(this)}>
          <div className="campaign-read__header-admin">
            <strong className="campaign-read__companyName">{t("Advertising group")}</strong>
            <h1 className="campaign-read__h1">{name}</h1>
            {this.renderDateSection()}
            <div className="campaign-read__current-status">
              <span className={`campaign-read__state campaign-read__state--${status}`}>
                {this.renderStatus()}
              </span>
            </div>
            <span>{this.renderLocations(this.props.locations)}</span>
            {this.renderMenu(hasPermissionsToReadCampaign)}

            {this.renderChart()}
            {this.renderActionButtons()}
          </div>
          {disclaimer}
          <div
            className={campaignMiddleSectionStyles}
            style={{ minHeight: "calc(100vh + 200px)" }}
            ref={(div) => {
              this.middleDiv = div;
            }}
          >
            <div className="campaign-read__insights">
              {this.renderTopMetricSection()}
              <h2>{t("Master data")}</h2>
              {this.renderBasicData()}

              {hasChannel("facebook", channels) && (
                <div>
                  <h2>
                    <svg className="svg-icon" viewBox="0 0 20 20">
                      <path
                        fill="none"
                        d="M10,0.5c-5.247,0-9.5,4.253-9.5,9.5c0,5.247,4.253,9.5,9.5,9.5c5.247,0,9.5-4.253,9.5-9.5C19.5,4.753,15.247,0.5,10,0.5 M10,18.637c-4.77,0-8.636-3.867-8.636-8.637S5.23,1.364,10,1.364S18.637,5.23,18.637,10S14.77,18.637,10,18.637 M10.858,7.949c0-0.349,0.036-0.536,0.573-0.536h0.719v-1.3H11c-1.38,0-1.866,0.65-1.866,1.743v0.845h-0.86V10h0.86v3.887h1.723V10h1.149l0.152-1.299h-1.302L10.858,7.949z"
                      ></path>
                    </svg>
                    Facebook
                  </h2>
                  {this.renderFacebookStats()}
                </div>
              )}
              {hasChannel("instagram", channels) && (
                <div>
                  <h2>
                    <svg className="svg-icon" viewBox="0 0 20 20">
                      <path
                        fill="none"
                        d="M9.969,0.594c-5.195,0-9.406,4.211-9.406,9.406c0,5.195,4.211,9.406,9.406,9.406c5.195,0,9.406-4.211,9.406-9.406C19.375,4.805,15.164,0.594,9.969,0.594 M9.969,18.552c-4.723,0-8.551-3.829-8.551-8.552s3.829-8.551,8.551-8.551S18.521,5.277,18.521,10S14.691,18.552,9.969,18.552 M12.534,5.724H7.403c-0.944,0-1.71,0.766-1.71,1.71v5.131c0,0.944,0.766,1.71,1.71,1.71h5.131c0.944,0,1.71-0.766,1.71-1.71V7.435C14.244,6.49,13.479,5.724,12.534,5.724M11.679,7.007h1.283V8.29h-1.283V7.007z M9.969,8.29c0.944,0,1.71,0.766,1.71,1.71s-0.766,1.71-1.71,1.71s-1.71-0.766-1.71-1.71S9.024,8.29,9.969,8.29 M13.39,12.565c0,0.472-0.384,0.854-0.855,0.854H7.403c-0.472,0-0.855-0.383-0.855-0.854V9.573h0.898C7.423,9.712,7.403,9.854,7.403,10c0,1.417,1.149,2.565,2.565,2.565c1.416,0,2.565-1.148,2.565-2.565c0-0.146-0.02-0.288-0.043-0.427h0.898V12.565z"
                      ></path>
                    </svg>
                    Instagram
                  </h2>
                  {this.renderInstagramStats()}
                </div>
              )}
              {hasChannel("google-display", channels) && (
                <div>
                  <h2>Google Display</h2>
                  <div className="campaign-read__social campaign-read__facebook">
                    {this.renderGoogleMetrics("google-display")}
                    <div className="campaign-read__social-preview"></div>
                  </div>
                </div>
              )}

              {hasChannel("youtube", channels) && (
                <div>
                  <h2>YouTube</h2>
                  <div className="campaign-read__social campaign-read__facebook">
                    {this.renderGoogleMetrics("youtube")}
                    <div className="campaign-read__social-preview"></div>
                  </div>
                </div>
              )}

              {hasChannel("twitter", channels) && (
                <div>
                  <h2>Twitter</h2>
                  <div className="campaign-read__social campaign-read__facebook">
                    {this.renderTwitterMetrics()}
                    <div className="campaign-read__social-preview"></div>
                  </div>
                </div>
              )}

              {_.intersection(channels, [
                "ebay-kleinanzeigen",
                "pinterest",
                "linkedin",
                "indeed",
                "xing",
                "google-search",
                "snapchat",
                "spotify"
              ]).length > 0 && (
                <div>
                  <h2>{t("Other sources")}</h2>
                  <div className="campaign-read__social campaign-read__facebook">
                    {this.renderOtherMetrics()}
                    <div className="campaign-read__social-preview"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {hasPermissionsToReadCampaign && (
            <CampaignSidebar
              userId={userProfile.userId}
              userRole={userProfile.status}
              heightY={heightY}
              userName={userProfile.userName}
              superRank={userProfile.superRank}
              orgaId={orgaId}
              campaignManager={campaignManager}
              orgaName={organization && organization.name}
              companyName={companyName}
              status={status}
              lastStatus={lastStatus}
              campaignId={tbCampaignId}
            />
          )}
        </div>

        {previews && (
          <AdPreview
            showModal={showModal}
            previews={previews && previews[1]}
            changeVisibility={this.changeVisibility.bind(this)}
          />
        )}
        <ReactTooltip className="campaign-read__tooltip" />
      </div>
    );
  }
}

export default withTranslation()(CampaignRead);
